import { render, staticRenderFns } from "./addFiles.vue?vue&type=template&id=2ce22c88&scoped=true&"
import script from "./addFiles.vue?vue&type=script&lang=js&"
export * from "./addFiles.vue?vue&type=script&lang=js&"
import style0 from "./addFiles.vue?vue&type=style&index=0&id=2ce22c88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce22c88",
  null
  
)

export default component.exports